import BtnGrid from '@App/components/BtnGrid/BtnGrid'
import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'
import Badge from '@App/components/Badge/Badge'

import './traps-toggles.styl'

function TrapsToggles({ smartTrapFilterIds = [], toggleSmartTrapFilterId }) {
  return (
    <div className="traps-toggles">
      <BtnGrid>
        <IconBtnHor
          iconProps={{ icon: '/img/icons/types/other/trap.svg', size: '21px' }}
          badge={<Badge color="#FF0000" type="hexagon" />}
          inactive={!smartTrapFilterIds.includes('active')}
          onClick={() => toggleSmartTrapFilterId('active')}
        >
          Active traps
        </IconBtnHor>
        <IconBtnHor
          iconProps={{ icon: '/img/icons/types/other/trap.svg', size: '21px' }}
          badge={<Badge color="#723FBE" type="hexagon" />}
          inactive={!smartTrapFilterIds.includes('passive')}
          onClick={() => toggleSmartTrapFilterId('passive')}
        >
          Passive traps
        </IconBtnHor>
        <IconBtnHor
          iconProps={{ icon: '/img/icons/types/other/trap.svg', size: '21px' }}
          badge={<Badge color="#7F7F7F" type="hexagon" />}
          inactive={!smartTrapFilterIds.includes('inactive')}
          onClick={() => toggleSmartTrapFilterId('inactive')}
        >
          Inactive traps
        </IconBtnHor>
      </BtnGrid>
    </div>
  )
}

export default TrapsToggles
